import { KeyValuePair } from '../../../../base/models'

/**
 * "Deneme Kartı Hariç" (Faz-37 §1c): test bayileri varsayılan olarak raporlardan çıkarılır.
 * Bayi kodları ön yüzde TUTULMAZ; liste sunucu ayarıdır (`Chatbot:Analytics:TestDealerSapCodes`).
 */
export const DEFAULT_EXCLUDE_TEST_DEALERS = true

export const EXCLUDE_TEST_DEALERS_LABEL = 'Deneme Kartı Hariç'

/** Her admin isteğine (Excel dahil) açıkça eklenir; değer verilmezse varsayılan `true` gider. */
export const addExcludeTestDealers = (query: KeyValuePair<string>, value?: boolean): void => {
  query.add('excludeTestDealers', String(value ?? DEFAULT_EXCLUDE_TEST_DEALERS))
}

/**
 * Faz-41 "Bayi Tipi": Vodafone bayisi tanımı sunucudadır (`TableDealer.IsVodafone = 1`, sitenin
 * geri kalanıyla aynı kural) — ön yüz yalnız seçimi gönderir, bayi kodu TUTMAZ.
 */
export type DealerTypeFilter = 'vodafone' | 'normal'

export const DEALER_TYPE_OPTIONS: { value: '' | DealerTypeFilter; label: string }[] = [
  { value: '', label: 'Tüm Bayiler' },
  { value: 'vodafone', label: 'Vodafone Bayileri' },
  { value: 'normal', label: 'Normal Bayiler' },
]

/** Boş seçim "tümü" demektir ve parametre hiç gönderilmez. */
export const addDealerType = (query: KeyValuePair<string>, value?: DealerTypeFilter): void => {
  if (value) query.add('dealerType', value)
}
